/** Calgary uses the America/Edmonton IANA zone, including daylight saving time. */
export const CALGARY_TIME_ZONE = 'America/Edmonton';

/** Calendar date of an instant in Calgary, independent of the browser's timezone. */
export function calgaryDateString(instant: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: CALGARY_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(instant);
  const part = (type: string) => parts.find(p => p.type === type)!.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/**
 * Calgary's calendar day in a local Date for date pickers/calendar arithmetic.
 * This is a calendar value, NOT an instant: never serialize it as a timestamp.
 */
export function calgaryCalendarDate(instant: Date = new Date()): Date {
  const [year, month, day] = calgaryDateString(instant).split('-').map(Number);
  return new Date(year, month - 1, day);
}

/** Add calendar days without crossing a date boundary due to UTC or DST. */
export function addCalendarDays(day: string, days: number): string {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, date + days)).toISOString().slice(0, 10);
}
